import {
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Text,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  FormControl,
  FormLabel,
  Tooltip,
  Input,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { IoColorPaletteOutline } from "react-icons/io5";
import {
  BsBlockquoteRight,
  BsClipboard2Check,
  BsPencil,
  BsPhone,
  BsWhatsapp,
} from "react-icons/bs";
import { HiShare } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { sendGreetingsDiary } from "../../../../Redux/App/action";
const CustomizeCard = () => {
  const params = useParams();
  const id = params._id;
  const [customCard, setCustomCards] = useState([]);
  const boxRef = useRef(null);
  const [boxHeight, setBoxHeight] = useState(null);
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [guestName, setguestName] = useState("");
  const [guestPhoneNumber, setguestPhoneNumber] = useState("");
  const [guestEmail, setguestEmail] = useState("");
  const [specialNote, setspecialNote] = useState("");
  const [customizedTemplateId, setcustomizedTemplateId] = useState("");
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  useEffect(() => {
    if (boxRef.current) {
      const height = boxRef.current.offsetHeight;
      setBoxHeight(height);
    }
  }, []);
  const getCustomData = async () => {
    try {
      const response = await axios.get(
        `https://dev.api.wishfy.io/media/canvas/get/canvastemplate?sourceMediaId=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        setCustomCards(response.data);
      }
    } catch (error) {
      console.clear(error);
    }
  };

  const getTemplateData = async () => {
    try {
      const response = await axios.get(
        `https://1eb4-103-12-133-136.ngrok-free.app/template/template-builder/by-source-media-id?sourceMediaId=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": true,
          },
        },
      );
      if (response.status === 200) {
        console.clear(response.data);
      }
    } catch (error) {
      console.clear(error);
    }
  };

  useEffect(() => {
    getTemplateData();
    getCustomData();
  }, []);

  const handleSendGreetings = () => {
    const formData = new FormData();
    formData.append(
      "greetingsDetails[0].customizedTemplateId",
      customizedTemplateId,
    );
    formData.append("specialNote", specialNote);
    formData.append("greetingsDetails[0].guestName", guestName);
    formData.append("greetingsDetails[0].guestPhoneNumber", guestPhoneNumber);
    formData.append("greetingsDetails[0].guestEmail", guestEmail);
    dispatch(sendGreetingsDiary(formData));
    onClose();
  };

  const shareToWhatsApp = async () => {
    let response = {};
    try {
      response = await axios.get(
        `https://1eb4-103-12-133-136.ngrok-free.app/template/template-builder/by-source-media-id?sourceMediaId=${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "ngrok-skip-browser-warning": true,
          },
        },
      );
      if (response.status === 200) {
        console.clear(response.data);
      }
    } catch (error) {
      console.clear(error);
    }
    console.clear(`response.data.payload.data`, response.data);
    const data = {
      canvasImgJson: JSON.parse(response.data.payload.data),
    };
    const res = await axios({
      method: "post",
      url: "https://dev.api.wishfy.io/canvas-api/canvas-img-builder/getimg",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-Type": "application/json",
      },
      data: data,
    });
    console.clear(res.data);
    const whatsappUrl = `https://wa.me/send?text=Share via Wishfy ${res.data}`;
    window.open(whatsappUrl);
  };
  return (
    <Flex px={5}>
      {customCard &&
        customCard.map((el, i) => (
          <Box w={"70%"} ref={boxRef} key={i} py={4}>
            <Image src={el.imageUrl} w={"50%"} h={boxHeight} m={"auto"} />
          </Box>
        ))}
      <Box w={"30%"} pt={2}>
        <Text fontWeight={"bold"} fontSize={20}>
          Go To Wishfy Editor
        </Text>
        <Flex justifyContent={"center"} alignItems={"center"} gap={5}>
          <Link to={"/canvas"}>
            <Button
              colorScheme="blue"
              w={"90%"}
              fontWeight={"bold"}
              fontSize={20}
              mt={5}
              borderRadius={20}
            >
              Customize
            </Button>
          </Link>
          <Tooltip label="Share Without Customize">
            <Button
              bg={"#f2ebfd"}
              variant="ghost"
              color="black"
              _hover={{
                bg: "#f2ebfd",
                boxShadow:
                  "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px inset, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px inset;",
              }}
              fontWeight={"bold"}
              fontSize={20}
              mt={5}
              borderRadius={20}
              onClick={onOpen}
            >
              <Flex alignItems={"center"} gap={2}>
                <HiShare size={20} fontWeight={"bold"} color="black" />
                <Text>Share</Text>
              </Flex>
            </Button>
          </Tooltip>
          <Button mt={5} colorScheme="whatsapp" onClick={shareToWhatsApp}>
            <BsWhatsapp size={20} />
          </Button>
          <Modal
            initialFocusRef={initialRef}
            finalFocusRef={finalRef}
            isOpen={isOpen}
            onClose={onClose}
          >
            <ModalOverlay />
            <ModalContent
              position="fixed"
              right="0"
              top="0"
              bg="#f2eee8"
              w={"80"}
            >
              <ModalHeader fontWeight={"bold"} fontSize={22} borderRadius={0}>
                Send <span style={{ color: "#fe1c58" }}>Greetings!</span>
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <FormControl isRequired>
                  <FormLabel>Guest Name</FormLabel>
                  <Input
                    ref={initialRef}
                    name="guestName"
                    value={guestName}
                    placeholder="guestName"
                    onChange={(e) => setguestName(e.target.value)}
                  />
                </FormControl>

                <FormControl mt={4} isRequired>
                  <FormLabel>Guest Phone Number</FormLabel>
                  <Input
                    placeholder="guestPhoneNumber"
                    type="number"
                    name="guestPhoneNumber"
                    value={guestPhoneNumber}
                    onChange={(e) => setguestPhoneNumber(e.target.value)}
                  />
                </FormControl>
                <FormControl mt={4} isRequired>
                  <FormLabel>Guest Email</FormLabel>
                  <Input
                    placeholder="guestEmail"
                    type="email"
                    name="guestEmail"
                    value={guestEmail}
                    onChange={(e) => setguestEmail(e.target.value)}
                  />
                </FormControl>
                <FormControl mt={4}>
                  <FormLabel>Special Note</FormLabel>
                  <Textarea
                    placeholder="specialNote"
                    type="text"
                    name="specialNote"
                    value={specialNote}
                    onChange={(e) => setspecialNote(e.target.value)}
                  />
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button
                  colorScheme="green"
                  mr={3}
                  onClick={handleSendGreetings}
                >
                  Send
                </Button>
                <Button onClick={onClose} colorScheme="red">
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Flex>
        <Divider mt={5} mb={5} border={"1px solid gray"} />
        <Flex gap={10} textAlign={"left"} px={2} mt={2} alignItems={"center"}>
          <IoColorPaletteOutline size={60} />
          <Text fontSize={14} fontWeight={"normal"}>
            Change your Card’s text, style, envelope, stamp, backdrop, and more.
            Add additional text boxes where you want them.
          </Text>
        </Flex>
        <Flex gap={10} textAlign={"left"} px={2} mt={2} alignItems={"center"}>
          <BsPencil size={60} />
          <Text fontSize={14} fontWeight={"normal"}>
            Personalize with your event’s details, make or import a guest list,
            and send with a click.
          </Text>
        </Flex>
        <Flex gap={10} textAlign={"left"} px={2} mt={2} alignItems={"center"}>
          <BsBlockquoteRight size={60} />
          <Text fontSize={14} fontWeight={"normal"}>
            Use customizable Blocks for schedule, registry, accommodations,
            travel details, and more.
          </Text>
        </Flex>
        <Flex gap={10} textAlign={"left"} px={2} mt={2} alignItems={"center"}>
          <BsPhone size={60} />
          <Text fontSize={14} fontWeight={"normal"}>
            Send your way, via email, text message, or a shareable link you can
            paste and post anywhere.
          </Text>
        </Flex>
        <Flex gap={10} textAlign={"left"} px={2} mt={2} alignItems={"center"}>
          <BsClipboard2Check size={60} />
          <Text fontSize={14} fontWeight={"normal"}>
            Instantly track opens and RSVPs, communicate with invitees, and use
            the app to check guests in on-site.
          </Text>
        </Flex>
      </Box>
    </Flex>
  );
};

export default CustomizeCard;
